import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyContentPanel, SurveyContentPanelInset } from '@/components/layout/SurveyContentPanel';
import { useTranslation } from '@/hooks/useTranslation';

export default function ThankYou() {
  const { t } = useTranslation();

  return (
    <SurveyBackgroundLayout>
      <div className="absolute z-10 inset-0 flex items-center justify-center">
        <SurveyContentPanelInset className="w-[86.4%]">
          <SurveyContentPanel className="flex min-h-[13.8rem] flex-col justify-center !py-[1.5rem] sm:min-h-[14.5rem]">
            <div className="mx-auto w-[95%]">
              <p className="m-0 leading-[1.75]">
                <span className="block">{t.thankYou.line1}</span>
                <span className="block">{t.thankYou.line2}</span>
              </p>
            </div>
          </SurveyContentPanel>
        </SurveyContentPanelInset>
      </div>
    </SurveyBackgroundLayout>
  );
}
